import { AppGlobalState } from 'modules/types'
import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

const basicSelectors = createBasicSelectors('pedigreedGrowerTargetSku')

export const PedigreedGrowerTargetSkuSelectors = {
  ...basicSelectors,
  updateCounter: (state: AppGlobalState) => state.pedigreedGrowerTargetSku.updateCounter,
  targetsTotal: (state: AppGlobalState) => state.pedigreedGrowerTargetSku.totalTargetValues,
  farmerOrdersTotal: (state: AppGlobalState) => state.pedigreedGrowerTargetSku.totalFarmerOrdersSku,
  previousYear: (state: AppGlobalState) => state.pedigreedGrowerTargetSku.totalFarmerOrdersSkuPreviousYear,
}

export default PedigreedGrowerTargetSkuSelectors
